import mediaLazyLoad from '../utils/rbata.mediaLazyLoad';

const storesSlider = {
    $sliderContainer: $('.article-page .slider'),
    sliders:          [],
    buildSlider(slider, nav) {
        this.sliders.push(tns({
            container:         slider,
            mode:              'carousel',
            items:             1,
            slideBy:           1,
            loop:              false,
            controls:          true,
            controlsContainer: nav,
            nav:               false,
            arrowKeys:         true,
            speed:             0,
            lazyload:          false,
            mouseDrag:         false,
            onInit:            () => {
                slider.classList.add('slider--initialized');
                mediaLazyLoad.refreshLazyLoad();
            },
        }));
    },
    navTemplate() {
        return `<nav class="js-slider__nav slider__nav">
                <button type="button" class="btn-reset slider__btn slider__btn--prev">
                    <svg class="icon slider__icon">
                        <use xlink:href="#icon-arrow-left-v2"></use>
                    </svg>
                </button>
                <button type="button" class="btn-reset slider__btn slider__btn--next">
                    <svg class="icon slider__icon">
                        <use xlink:href="#icon-arrow-right-v2"></use>
                    </svg>
                </button>
            </nav>`;
    },
    buildAllSliders() {
        this.$sliderContainer.each((index, item) => {
            let $item = $(item);

            $(item).parent().addClass('position-relative');
            $(item).after(this.navTemplate());
            this.buildSlider(item, $(item).next('nav')[0]);
        })
    }
};

// DOM ready
$(() => {
    if (storesSlider.$sliderContainer.length) {
        storesSlider.buildAllSliders();
    }
});
